import { NavigationStore } from './navigation-store';

export const isWaitingForRouteApproval = (store: NavigationStore) => store.pendingRoute !== false;
